import React, { useEffect, useState } from "react";
import { FullScreenDialog } from "../core/FullScreenDialog";
import { useAddSlugToGame, useMyProfile } from "@seabrookstudios/pitch2table";
import { SmartTextField } from "../core/SmartTextField";
import Skeleton from "@mui/material/Skeleton";
import { shortUrl } from "../games/model";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {boolean} props.shouldDisable
 */
export default function Add({ gameId, shouldDisable }) {
  const { data: profile } = useMyProfile();

  const [slug, setSlug] = useState("");
  const [canSave, setCanSave] = useState(true);

  const addSlug = useAddSlugToGame(gameId);

  const onSaveHandler = async () => {
    await addSlug.mutateAsync(slug);
  };

  useEffect(() => {
    setCanSave(slug.length === 0);
  }, [slug]);

  return (
    <FullScreenDialog
      title="Add Slug"
      canSave={canSave}
      actionText="SAVE"
      onSaveHandler={onSaveHandler}
      isBusy={addSlug.isPending}
      disabled={shouldDisable}
    >
      <SmartTextField
        label="Slug"
        initialValue={slug}
        onChange={setSlug}
        helperText2={!profile ? <Skeleton /> : `Short url: ${shortUrl(profile.slug, slug)}`}
      />
    </FullScreenDialog>
  );
}
